export default __webpack_public_path__ + "static/tech-prometheus-a7dcee35e78dc1d81752ef09b419760c-a7dcee35e78dc1d81752ef09b419760c.png";